import React from "react";
import "../static/upcomingEvents.css";
import "../../../globals/index.css";
import { locale, formatAMPM } from "../../../utils/consts";
export default function UpcomingEvents({ eventsList }) {
  const [loading, setLoading] = React.useState(new Array(5).fill(true));
  const imageLoaded = (eventIndex) => {
    loading[eventIndex] = false;
    setLoading({ ...loading });
  };
  return (
    <div className="container-fluid d-flex flex-row overflow-auto position-relative eventsContainer pt-3 pl-xl-6 pl-lg-6 pl-md-6 mb-xl-5 mb-lg-5 mb-md-5 mb-sm-5 mb-5">
      {eventsList.map((event, eventIndex) => {
        let isLive = false;
        if (
          event.start >= new Date().getTime() &&
          event.end <= new Date().getTime()
        ) {
          isLive = true;
        }
        let eventDate = new Date(event.start);
        let date = eventDate.getDate();
        let day = eventDate.toLocaleDateString(locale, { weekday: "short" });
        let month = eventDate.toLocaleString(locale, { month: "short" });
        let startTime = formatAMPM(eventDate);
        return (
          <div className="mr-xl-4 mr-lg-4 mr-md-4 mr-sm-4 mr-3 rounded ">
            <a
              href={`${
                process.env.REACT_APP_WEB_BASE_URL
              }/e/${event.title.replace(/\s+/g, "-")}-${event.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div
                className={
                  loading[eventIndex]
                    ? "shine upcomingeventscardShine"
                    : "upcomingEventsContainer row justify-content-center rounded"
                }
              >
                <img
                  className="upcomingEventsImg rounded"
                  src={event.displayPicture}
                  onLoad={() => imageLoaded(eventIndex)}
                />
                {isLive && (
                  <div className="live position-absolute top-right bg-danger text-white rounded px-lg-2 px-xl-2 px-md-2 px-sm-2 px-2 py-1 m-xl-3 m-lg-3 m-md-2 m-sm-2 m-2">
                    LIVE
                  </div>
                )}
                <div
                  className={
                    loading[eventIndex]
                      ? "displayNone position-absolute w-100 px-2 bottom"
                      : "position-absolute w-100 px-2 bottom"
                  }
                >
                  <div className="eventTitle text-start pt-sm-2 pt-2 pl-sm-1 pl-1 pr-sm-0 pr-0">
                    {event.title}
                  </div>
                  <div className="eventDate text-start pb-sm-2 pb-2 pt-sm-1 pt-1 pl-sm-1 pl-1 pr-sm-0 pr-0">
                    {day}, {date} {month}, {startTime}
                  </div>
                </div>
              </div>
            </a>
            {event.genreNames.length && (
              <div className="d-flex flex-row">
                {event.genreNames.map((genreName) => {
                  return (
                    <div
                      className={
                        loading[eventIndex]
                          ? "displayNone genre py-0 px-2 mt-3 mr-1 ml-2 rounded"
                          : "genre py-0 px-2 mt-3 mr-1 ml-2 rounded"
                      }
                    >
                      {genreName}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/UpcomingEvents.jsx